export default __webpack_public_path__ + "static/media/star1.50956e8f.gif";